import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import CustomFormPage from "@/pages/CustomFormPage";

export const Route = createFileRoute("/f/$slug")({ head: ({ params }) => routeMeta('Submit Details | MNRE', 'Submit your details securely to MNRE.', `/f/${params.slug}`), component: CustomFormPage });
